import { useNavigationEventBus as u } from "@ado/acs-standard-library";
var I = /* @__PURE__ */ ((i) => (i.ExpandOnHover = "EXPAND_ON_HOVER", i.ExpandOnClick = "EXPAND_ON_CLICK", i))(I || {}), c = /* @__PURE__ */ ((i) => (i.Link = "LINK", i.Button = "BUTTON", i.Custom = "CUSTOM", i))(c || {});
const E = "_blank", T = "_self";
class a {
  id;
  type;
  navigationEventBus;
  slotName;
  additionalInfo;
  link;
  title;
  isVisible;
  isIntendedForShowingInNewTab;
  onClickHandler;
  constructor(t) {
    const {
      id: n,
      type: e,
      navigationEventBus: s = u(),
      title: o = "",
      link: l = "#",
      onClickHandler: h = () => {
      },
      slotName: r,
      isVisible: d = !0,
      additionalInfo: N
    } = t;
    if (!n)
      throw new Error("Id must be defined.");
    if (e === "CUSTOM" && !r)
      throw new Error("The slot name must be defined for a custom menu item.");
    this.id = n, this.type = e, this.navigationEventBus = s, this.title = o, this.link = l, this.onClickHandler = h, this.slotName = r, this.isVisible = d, this.isIntendedForShowingInNewTab = !1, this.additionalInfo = N;
  }
  setIsVisible(t) {
    return this.isVisible = t, this;
  }
  markAsIntendedForShowingInNewTab() {
    return this.isIntendedForShowingInNewTab = !0, this;
  }
  setOnClickHandler(t) {
    return this.onClickHandler = t, this;
  }
  handleClick = () => {
    this.onClickHandler(), this.type === "LINK" && this.navigationEventBus.navigate(this.link, this.target);
  };
  get target() {
    return this.isIntendedForShowingInNewTab ? E : T;
  }
  static newButtonItem(t, n, e, s) {
    return new a({
      id: t,
      type: "BUTTON",
      title: n,
      onClickHandler: e,
      navigationEventBus: s
    });
  }
  static newCustomItem(t, n, e, s) {
    return new a({
      id: t,
      type: "CUSTOM",
      slotName: n,
      additionalInfo: e,
      navigationEventBus: s
    });
  }
  static newLinkItem(t, n, e, s) {
    return new a({
      id: t,
      type: "LINK",
      title: n,
      link: e,
      navigationEventBus: s
    });
  }
}
export {
  a as DropdownMenuItem,
  c as DropdownMenuItemTypes,
  I as DropdownMenuTypes
};
//# sourceMappingURL=index3.js.map
